// 下划线转驼峰方法
const toCamelCase = (str) => {
  // 如果字符串中没有下划线，直接返回原字符串
  if (!str || str.indexOf('_') === -1) {
    return str;
  }
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export default toCamelCase;